import { all, takeLatest } from 'redux-saga/effects';
import { Types as SitesTypes } from '../ducks/sites';
import { Types as StatesTypes } from '../ducks/states';
import { Types as SubscriptionTypes } from '../ducks/subscription';
import { Types as NewspapersTypes } from '../ducks/newspapers';
import { Types as NewspaperTypes } from '../ducks/newspaper';
import { Types as FaqTypes } from '../ducks/faq';
import { Types as TermsOfUseTypes } from '../ducks/termsOfUse';
import { Types as PrivacyPolicyTypes } from '../ducks/privacyPolicy';
import { Types as SignupTypes } from '../ducks/signup';
import { Types as PasswordTypes } from '../ducks/password';
import { Types as ResetPWTypes } from '../ducks/resetPassword';
import { Types as SessionTypes } from '../ducks/session';
import { Types as UserTypes } from '../ducks/user';
import { Types as CreditCardTypes } from '../ducks/creditCard';
import { Types as CampaignCreators } from '../ducks/campaigns';

import { getSite } from './sites';
import { getStates } from './states';
import { fetchNewspapers, fetchFavoritesNewspapers, searchNewspapers } from './newspapers';
import { getFaq } from './faq';
import { getTermsOfUse } from './termsOfUse';
import { getPrivacyPolicy } from './privacyPolicy';
import { signup } from './signup';
import { forgot, checkPin } from './password';
import { checkToken, resetPassword } from './resetPassword';
import { clearMessagesOnChangePage } from './messages';
import { getNewspaper } from './newspaper';
import {
  getSubscription,
  getSubscriptionMobile,
  getPayments,
  cancelSubscription,
  applyVoucher,
  getVouchers,
} from './subscription';
import { authenticate, invalidate, saveSession, authBytoken } from './session';
import { refrash, updateUser, getUserConfirmation, updateUserConfirmation } from './user';
import { subscription } from './creditCard';
import { getCampaign } from './campaigns';

export default function* rootSaga() {
  yield all([
    takeLatest(SessionTypes.CREATE, authenticate),
    takeLatest(SessionTypes.DESTROY, invalidate),
    takeLatest(SessionTypes.SAVE, saveSession),
    takeLatest(SessionTypes.AUTH_BY_TOKEN, authBytoken),
    takeLatest(UserTypes.REFRASH, refrash),
    takeLatest(UserTypes.UPDATE, updateUser),
    takeLatest(UserTypes.GET_REQUEST, getUserConfirmation),
    takeLatest(UserTypes.UPDATE_CONFIRMATION, updateUserConfirmation),
    takeLatest(SitesTypes.GET_REQUEST, getSite),
    takeLatest(StatesTypes.GET_REQUEST, getStates),
    takeLatest(SubscriptionTypes.GET_SUBSCRIPTION_REQUEST, getSubscription),
    takeLatest(SubscriptionTypes.GET_SUBSCRIPTION_MOBILE_REQUEST, getSubscriptionMobile),
    takeLatest(SubscriptionTypes.GET_PAYMENTS_REQUEST, getPayments),
    takeLatest(SubscriptionTypes.CANCEL_SUBSCRIPTION_REQUEST, cancelSubscription),
    takeLatest(SubscriptionTypes.POST_VOUCHERS_APPLY_REQUEST, applyVoucher),
    takeLatest(SubscriptionTypes.GET_VOUCHERS_REQUEST, getVouchers),
    takeLatest(NewspapersTypes.GET_RECENTS, fetchNewspapers),
    takeLatest(NewspapersTypes.GET_REGIONALS, fetchNewspapers),
    takeLatest(NewspapersTypes.GET_HIGHLIGHTS, fetchNewspapers),
    takeLatest(NewspapersTypes.GET_FAVORITES, fetchFavoritesNewspapers),
    takeLatest(NewspapersTypes.GET_SEARCH, searchNewspapers),
    takeLatest(NewspaperTypes.GET_REQUEST, getNewspaper),
    takeLatest(FaqTypes.GET_REQUEST, getFaq),
    takeLatest(TermsOfUseTypes.GET_REQUEST, getTermsOfUse),
    takeLatest(PrivacyPolicyTypes.GET_REQUEST, getPrivacyPolicy),
    takeLatest(ResetPWTypes.CHECK_TOKEN, checkToken),
    takeLatest(ResetPWTypes.RESET_REQUEST, resetPassword),
    takeLatest(PasswordTypes.FORGOT, forgot),
    takeLatest(PasswordTypes.PIN, checkPin),
    takeLatest(SignupTypes.REQUEST, signup),
    takeLatest(CreditCardTypes.REQUEST, subscription),
    takeLatest(CampaignCreators.GET, getCampaign),
    takeLatest('@@router/LOCATION_CHANGE', clearMessagesOnChangePage),
  ]);
}



// WEBPACK FOOTER //
// ./src/store/sagas/index.js